export default __webpack_public_path__ + "static/media/landing-img.0ccd51a3.jpg";